import { COLORS } from '@btime/constants'
import { useDrop } from 'react-dnd'
import React from 'react'

import Center from '../../packages/kiti/components/helpers/Center'
import IconText from '../presentation/IconText'
import Panel from '../../packages/kiti/components/structure/Panel'

const EmptyDroppablePanel = ({ onDrop, type, children, label, ...props }) => {
  const [{ borderColor }, dropRef] = useDrop({
    accept: type,
    drop(item, monitor) {
      onDrop(item)
    },
    collect: monitor => ({
      borderColor: monitor.isOver() ? 'green' : 'light2'
    })
  })

  return (
    <div ref={dropRef}>
      <Panel noMargin borderColor={borderColor} mediumPadding {...props}>
        <Center>
          <IconText iconName="BsBoxArrowInDown" color={COLORS.dark4} label={label || 'Arraste aqui'} />
        </Center>
      </Panel>
    </div>
  )
}

export default EmptyDroppablePanel
